module.exports = __webpack_public_path__ + "static/media/playlists.51412d91.png";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/music/playlists.png
// module id = 707
// module chunks = 0